module.exports = __webpack_public_path__ + "img/Logo dentalia-blue.78eac9ed.png";